import React from "react";
import Framework from "@beardeddevops/react.framework";
import {Objects, Types} from "components";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import CardHeader from "@material-ui/core/CardHeader";
import Select from "react-select";
import API from "@beardeddevops/react.api";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import {Tooltip} from "@material-ui/core";
import UserRoles from "../../constants/UserRoles";
import moment from "moment-timezone";

export default class Refund extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Refunds._name);
		this.state.sub_regions = [];
		this.state.selectedSubRegion = null;
		this.state.isGeneric = true;
		this.state.userRoles = this.props.userRoles;
		this.state.selectedUserRoles = [];
	}

	form = () => {
		/**
		 * @param {Refunds_Properties} data
		 */
		let {properties} = this.model

		/**
		 * @type {Refunds_Object} object
		 */
		let object = this.state
		let {loading} = this.state

		return (
			<div>
				<Card>
					<fieldset>
						<div className={"row"}>
							<div className={'col-lg-4'}>
								<div className="form-group">
									<Framework.Elements.Select
										shouldLoad={this.state.loaded}
										property={properties.customer}
										value={object.customer}
										error={object.customer_error}
										object={object.customers}
										update={this.handleSelectPropertyUpdate}
										nullable={true}
									/>
								</div>
							</div>

							<div className={'col-lg-4'}>
								<div className="form-group">
									<Framework.Elements.Select
										shouldLoad={true}
										property={properties.field_engineer}
										value={object.field_engineer}
										error={object.field_engineer_error}
										object={object.users_related_by_field_engineer}
										update={this.handleSelectPropertyUpdate}
										requestOverride={"GET_FIELD_ENGINEERS"}
										limit={null}
										text={"name_first&name_last"}
										showToolTip={true}
										nullable={true}
									/>
								</div>
							</div>

							<div className={"col-lg-4 col-sm-12"}>
								<div className="form-group">
									<Framework.Elements.TextField
										property={properties.amount}
										value={object.amount}
										label={"Refund Amount"}
										error={object.amount_error}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
							</div>
						</div>

						<div className={"row"}>
							<div className={"col-12"}>
								<div className="form-group">
									<Framework.Elements.TextField
										property={properties.notes}
										value={object.notes}
										label={"Original amount, FreshDesk Ticket, other notes, etc..."}
										error={object.notes_error}
										update={this.handleTextFieldPropertyUpdate}
										multiline={4}
									/>
								</div>
							</div>
						</div>
					</fieldset>
				</Card>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	}
}
